import { useState } from 'react';
import { useQuery, useMutation } from '@tanstack/react-query';
import { api } from '../lib/api';

export function GamePanel() {
  const [selectedGame, setSelectedGame] = useState<string | null>(null);
  const [score, setScore] = useState(0);

  const { data: gameTypes } = useQuery({
    queryKey: ['game-types'],
    queryFn: () => api.getGameTypes(),
  });

  const { data: dailyGames } = useQuery({
    queryKey: ['daily-games'],
    queryFn: () => api.getDailyGames(),
  });

  const submitScore = useMutation({
    mutationFn: ({ gameType, score }: { gameType: string; score: number }) =>
      api.submitScore(1, gameType, score), // TODO: Get actual player ID
  });

  const games = (gameTypes as { game_types?: Array<{ id: string; name: string; aoe: string; description: string }> })?.game_types || [];
  const todayGames = (dailyGames as { assignments?: Array<{ id: number; aoe_type: string; game_type: string }> })?.assignments || [];

  return (
    <div className="space-y-6">
      {/* Daily Assignments */}
      <div className="card">
        <h2 className="text-lg font-bold mb-4">📅 Today's Games</h2>
        <div className="grid grid-cols-3 gap-3">
          {todayGames.map((game) => (
            <div 
              key={game.id}
              className="bg-lunar-700 rounded-lg p-3 border border-lunar-600"
            >
              <div className="text-xs text-mars-400 mb-1">{game.aoe_type}</div>
              <div className="font-medium">{game.game_type}</div>
            </div>
          ))}
          {todayGames.length === 0 && (
            <div className="col-span-3 text-center text-lunar-400 py-4">
              No games assigned for today
            </div>
          )}
        </div>
      </div>

      {/* Game Grid */}
      <div className="card">
        <h2 className="text-lg font-bold mb-4">🎮 Arcade</h2>
        <div className="grid grid-cols-3 gap-4">
          {games.map((game) => (
            <button
              key={game.id}
              onClick={() => setSelectedGame(game.id)}
              className={`bg-lunar-700 hover:bg-lunar-600 rounded-lg p-4 text-left transition-colors ${
                selectedGame === game.id ? 'ring-2 ring-mars-400' : ''
              }`}
            >
              <div className="text-3xl mb-2">🎮</div>
              <div className="font-medium">{game.name}</div>
              <div className="text-xs text-lunar-400">{game.aoe}</div>
              <div className="text-xs text-mars-400 mt-1">{game.description}</div>
            </button>
          ))}
        </div>
      </div>

      {/* Score Submission (Dev Tool) */}
      {selectedGame && (
        <div className="card">
          <h3 className="font-bold mb-3">Submit Score: {selectedGame}</h3>
          <div className="flex gap-3">
            <input
              type="number"
              value={score}
              onChange={e => setScore(parseInt(e.target.value) || 0)}
              className="input flex-1"
              placeholder="Score"
            />
            <button
              onClick={() => submitScore.mutate({ gameType: selectedGame, score })}
              disabled={submitScore.isPending}
              className="btn-primary"
            >
              {submitScore.isPending ? 'Submitting...' : 'Submit'}
            </button>
          </div>
          {submitScore.isSuccess && (
            <div className="mt-3 text-sm text-green-400">
              ✅ Score submitted!
            </div>
          )}
        </div>
      )}
    </div>
  );
}
